<template>
    <div class="lawlex-custom-card">
      <div class="no-data-found-wrapper">
        <img :src="imageSrc" />
        <div>
          <!-- Dynamically display message based on the type -->
          <div v-if="isUserNotActive">{{ $t('msg_user_not_active') }}</div>
          <div v-else>{{ title }}</div>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: "NoDataOrUserNotActive",
    props: {
      // Determine if the user is not active
      isUserNotActive: {
        type: Boolean,
        required: true,
      },
      // Title for no data found message
      title: {
        type: String,
        default: "",
      },
      // The image source for the respective state
      imageSrc: {
        type: String,
        required: true,
      },
    },
  };
  </script>
